﻿'use strict';

var centralApp = angular.module('app.components');

centralApp.directive('visualizarArquivo', function () {

    return {
        restrict: 'A',
        scope: {
            arquivo: '=visualizarArquivo'
        },
        controllerAs: '$ctrl',
        controller: visualizarArquivoCtrl,
        link: function ($scope, $element, $attr) {

            $element.bind('click', function (e) {
                e.preventDefault();

                if ($scope.arquivo instanceof File || $scope.arquivo instanceof Blob) {

                    // Ler o arquivo de imagem
                    $scope.lerArquivo($scope.arquivo).then(function (base64) {
                        $scope.exibirImagem($scope.arquivo, base64);
                    });

                } else {
                    $scope.baixarArquivo();
                }

            });

        }
    }

});

visualizarArquivoCtrl.$inject = ['$scope', '$q', '$modal', 'notificacao', 'anexoApi'];

function visualizarArquivoCtrl($scope, $q, $modal, notificacao, anexoApi) {

    var $ctrl = $scope;

    $ctrl.baixarArquivo = baixarArquivo;
    $ctrl.lerArquivo = lerArquivo;
    $ctrl.exibirImagem = exibirImagem;


    /**
     * Realiza uma consulta na api para baixar 
     * o arquivo solicitado
     */
    function baixarArquivo() {
        $ctrl.arquivo.abrindo = true;
        anexoApi.baixarArquivo($ctrl.arquivo, function (resposta) {
            
            // Cria a instância do arquivo
            var arquivo = new Blob([resposta.data], {
                type: resposta.headers['content-type']
            });

            // Ler o arquivo de imagem
            $ctrl.lerArquivo(arquivo).then(function (base64) {
                $ctrl.src = base64;
                $ctrl.exibirImagem($ctrl.arquivo, base64);
            });

            $scope.arquivo.abrindo = false;
        }, function (error) {
            notificacao.erro('Houve um erro ao baixar o arquivo');
            $scope.arquivo.abrindo = false;
        });
    }

    /**
     * Ler o conteúdo do arquivo
     * 
     * @param Blob arquivo
     * 
     * @return $promise
     */
    function lerArquivo(arquivo) {

        var deferred = $q.defer();

        var reader = new FileReader();
        reader.onload = function (e) {
            deferred.resolve(e.target.result);
        };

        reader.onerror = function (e) {
            deferred.reject(e);
        };

        reader.readAsDataURL(arquivo);

        return deferred.promise;
    }

    /**
     * Responsável por aprensentar a modal
     * com a imagem
     * 
     * @param string base64(imagem)
     */
    function exibirImagem(arquivo, base64) {

        $modal({
            title: arquivo.arquivoNome || arquivo.name || 'Imagem',
            content: base64,
            scope: $ctrl,
            html: true,
            show: true,
            backdrop: true,
            template: require('./visualizar-arquivo-template.html'),
            onHide: function () {
                $('body').removeClass('modal-open')
            }
        });

    }
}


//////////////////
// WEBPACK FOOTER
// ../Projecao.ContactCenter.WebApp.Compartilhado/components/visualizar-arquivo/index.js
// module id = 322
// module chunks = 1